








































































































































import { vxm } from '@/store.vuex';
import { Vue, Component, Prop } from 'vue-property-decorator';
import CountTime from '../../time/CountTime.vue';
@Component({ components: { CountTime } })
export default class OTPLoginForm extends Vue {
  @Prop({ default: '' }) username;
  @Prop({ default: () => {} }) onLogin;
  @Prop({ default: () => {} }) setPassword;
  @Prop({ default: () => {} }) onResendOtp;
  @Prop({ default: () => {} }) goBack;
  @Prop({ default: () => {} }) onFinishCountdown;
  @Prop({ default: [] }) password;
  @Prop({ default: '' }) errors;
  @Prop({ default: '' }) confirmButtonName;
  @Prop({ default: '' }) onBackName;
  @Prop({ default: '' }) validationType;
  @Prop({ type: Number }) resendCodeSecondsToCount;
  @Prop({ default: false, type: Boolean }) canResendCode;
  @Prop({ default: true, type: Boolean }) showCounter;

  private MAX_DIGIT: number = 4;
  private copiedPassword: any = [];
  private object = {};
  private ALLOWED_KEYS = [
    'Backspace',
    'Delete',
    'ArrowLeft',
    'ArrowRight',
    'Enter',
  ];
  $wlToastr: any;

  mounted() {
    const codeInput = <HTMLInputElement>this.$refs.digit0;
    codeInput.focus();
  }

  passwordPasted(evt) {
    var pasted = evt.clipboardData.getData('Text').trim();
    this.copiedPassword = Array.from(pasted.toString()).map(Number);
    if (this.copiedPassword.length - 1 == this.MAX_DIGIT) {
      const lastCodeInput = <HTMLInputElement>this.$refs.digit4;
      Object.values(this.copiedPassword).forEach((value, index) => {
        this.object = { value, index };
        this.setPassword(this.object);
      });
      lastCodeInput.focus();
    }
  }

  onPasswordKeyUp(evt) {
    try {
      let EventKey = evt.key;
      const allowedKey = this.ALLOWED_KEYS.find((x) => x == evt.key);
      // evt.key is unidentified for alphanumeric values in android web browsers during keup/keydown event
      if (evt.key === 'Unidentified') {
        EventKey = evt.target.value;
      }
      if (isNaN(EventKey) && !allowedKey) return;
      const codeDigit = parseInt(evt.target.attributes['data-digit'].value);
      if (codeDigit >= this.MAX_DIGIT && !allowedKey) return;

      let box = 0;
      const moveBackward =
        evt.key === 'Backspace' ||
        evt.key === 'Delete' ||
        evt.key === 'ArrowLeft';
      if (moveBackward) {
        box = codeDigit == 0 ? 0 : codeDigit - 1;
      } else if (evt.key === 'Enter') {
        this.onLogin();
      } else {
        if (evt.target.value.length < 1 && evt.keyCode===229)return ;
        box = codeDigit + 1;
      }

      const input = <HTMLInputElement>(
        window.document.querySelector(`input[data-digit="${box}"]`)
      );
      // Validate the input
      if (!input) return;
      input.focus();
      input.select();
    } catch (err) {
      console.log(err);
    }
  }
  get supportEmail(): string {
    return vxm.configs.getGlobalConfigValue('SUPPORT_EMAIL') || vxm.utility.supportEmail;
  }

  get showSupportPhoneNumber(): boolean {
    return vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') ? true : false;
  }
  get supportPhoneNumber(): string {
    return (
      vxm.configs.getGlobalConfigValue('SUPPORT_PHONE_NUMBER') || vxm.utility.supportPhoneNo
    );
  }
}
